<template>
  <v-card color="tw-mt-4">
    <v-container>
      <!-- Documentation button -->
      <DocumentationDialogue class="tw-inline" path="manager/moderation/response" :key="$i18n.locale"/>

      <span v-if="review.moderate === 0" class="sr-title">
        {{ $t("dashboard.reviewsModeration.response.title") }}
      </span>
      <span v-else class="sr-title">
        {{ $t("dashboard.reviewsModeration.response_done.title") }}
      </span>

      <!-- Content of the response card -->
      <v-card-text>
        <v-stepper v-model="step" class="elevation-0">
          <v-stepper-items>
            <!-- Step 0 => Change a response -->
            <v-stepper-content :step="0" class="pa-0">
              <div class="sr-title mb-2">
                {{ $t("dashboard.reviewsModeration.response_done.moderation_done") }}
              </div>
              <div v-if="response.message">
                <span>{{ $t("dashboard.reviewsModeration.response_done.message") }}</span>
                <v-textarea v-model="response.message" filled name="response" readonly />
              </div>
              <div v-else>
                <span>{{ $t("dashboard.reviewsModeration.response_done.no_message") }}</span>
                <br />
                <br />
              </div>
              <v-btn class="tw-m-1" color="primary" small @click="step = 1">
                {{ $t("dashboard.reviewsModeration.response_done.buttons.change") }}
              </v-btn>
            </v-stepper-content>
            <!-- Step 1 => Make a response -->
            <v-stepper-content :step="1" class="pa-0">
              <span class="font-weight-bold">{{ $t("dashboard.reviewsModeration.response.message") }}</span>
              <v-textarea v-model="response.message" flat name="response" no-resize />
              <v-btn v-if="response.hasOwnProperty('id')" class="tw-m-1" small @click="remove">
                {{ $t("dashboard.reviewsModeration.response.buttons.delete") }}
              </v-btn>
              <v-btn class="tw-m-1" color="primary" small @click="reply">
                {{ $t("dashboard.reviewsModeration.response.buttons.update") }}
              </v-btn>
            </v-stepper-content>
            <!-- Step 2 => Make a choice -->
            <v-stepper-content :step="2" class="pa-0">
              <div class="tw-flex tw-justify-around tw-items-center tw-mt-4">
                <v-btn class="tw-w-1/3 tw-mx-2" small @click="step = 1">
                  {{ $t("dashboard.reviewsModeration.response.buttons.back") }}
                </v-btn>
                <v-btn class="tw-w-1/3 tw-mx-2" color="primary" small @click="step = 3">
                  {{ $t("dashboard.reviewsModeration.response.buttons.publish") }}
                </v-btn>
                <v-btn class="tw-w-1/3 tw-mx-2" color="primary" small @click="step = 4">
                  {{ $t("dashboard.reviewsModeration.response.buttons.report") }}
                </v-btn>
              </div>
            </v-stepper-content>
            <!-- Step 3 => Publish the review -->
            <v-stepper-content :step="3" class="pa-0">
              <span class="font-weight-bold">{{ $t("dashboard.reviewsModeration.response.publish") }}</span>
              <v-slider
                v-model="pertinence"
                :label="$t('dashboard.reviewsModeration.response.pertinence')"
                :thumb-color="pertinenceColor"
                class="mt-6"
                color="grey darken-1"
                max="9"
                min="1"
                thumb-label="always"
                thumb-size="20"
                track-color="grey lighten-1"
              />
              <v-btn class="mr-4" small @click="step = 2">
                {{ $t("dashboard.reviewsModeration.response.buttons.back") }}
              </v-btn>
              <v-btn color="primary" small @click="publish">
                {{ $t("dashboard.reviewsModeration.response.buttons.publish") }}
              </v-btn>
            </v-stepper-content>
            <!-- Step 4 => Report an alter on the review -->
            <v-stepper-content :step="4" class="pa-0">
              <span class="font-weight-bold">
                {{ $t("dashboard.reviewsModeration.response.report.title") }}
              </span>
              <v-select
                v-model="reason"
                :items="reasons"
                :label="$t('dashboard.reviewsModeration.response.report.label')"
                class="mt-2"
                item-text="text"
                item-value="value"
              />
              <v-btn class="mt-2 mr-4" small @click="step = 2">
                {{ $t("dashboard.reviewsModeration.response.buttons.back") }}
              </v-btn>
              <v-btn :disabled="reason === 0" class="mt-2" color="primary" small @click="report">
                {{ $t("dashboard.reviewsModeration.response.buttons.report") }}
              </v-btn>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </v-card-text>
    </v-container>
  </v-card>
</template>

<script>
import { Types as TypesDialog } from "../../../../store/modules/dialog"

export default {
  name: "response",
  props: {
    review: { required: true, default: {} },
    response: { required: true, default: { message: "" } },
    token: { required: true },
  },
  data: () => ({
    edit: false,
    pertinence: 5,
    reasons: [],
    reason: 0,
    step: 1,
  }),
  beforeDestroy() {
    if (this.locked) {
      this.free().then(() => {
        this.locked = false
      })
    }
  },
  mounted() {
    if (this.review.moderate === 1) {
      this.step = 0
    }
    this.reasons = [
      {
        value: 1,
        text: this.$t("dashboard.reviewsModeration.response.report.1"),
      },
      {
        value: 2,
        text: this.$t("dashboard.reviewsModeration.response.report.2"),
      },
      {
        value: 3,
        text: this.$t("dashboard.reviewsModeration.response.report.3"),
      },
      {
        value: 4,
        text: this.$t("dashboard.reviewsModeration.response.report.4"),
      },
      {
        value: 5,
        text: this.$t("dashboard.reviewsModeration.response.report.5"),
      },
      {
        value: 6,
        text: this.$t("dashboard.reviewsModeration.response.report.6"),
      },
      {
        value: 7,
        text: this.$t("dashboard.reviewsModeration.response.report.7"),
      },
      {
        value: 8,
        text: this.$t("dashboard.reviewsModeration.response.report.8"),
      },
      {
        value: 9,
        text: this.$t("dashboard.reviewsModeration.response.report.9"),
      },
    ]

    // Lock the review when the user display a review/response
    this.set()
  },
  computed: {
    updateDate() {
      return this.$moment(this.response.updated_at).from()
    },
    pertinenceColor() {
      switch (this.pertinence) {
        case 1:
          return "red darken-3"
        case 2:
          return "red"
        case 3:
          return "orange darken-3"
        case 4:
          return "orange"
        case 5:
          return "orange lighten-2"
        case 6:
          return "green darken-3"
        case 7:
          return "green darken-1"
        case 8:
          return "green"
        case 9:
          return "green lighten-2"
        default:
          return "grey"
      }
    },
  },
  methods: {
    reply() {
      this.$axios
        .post("office/manager/impersonate/response", {
          // Need to report the qualification here (40+qualification( 1-9 ))
          response: this.response,
          token: this.token,
        })
        .then(() => {
          this.step = 2
        })
    },
    publish() {
      this.$store.dispatch(TypesDialog.actions.CONFIRM, {
        title: this.$t("dashboard.reviewsModeration.dialogs.publish.title"),
        message: this.$t("dashboard.reviewsModeration.dialogs.publish.text"),
        callback: () => {
          this.$axios
            .post("office/manager/impersonate/response/moderate", {
              // Need to report the qualification here (40+qualification( 1-9 ))
              confidence: 40 + this.pertinence,
              response: this.response,
              token: this.token,
            })
            .then(() => {
              this.$emit("moderate", 1)
              this.$emit("confidence", 40 + this.pertinence)
              this.step = 0
            })
        },
      })
    },
    report() {
      this.$store.dispatch(TypesDialog.actions.CONFIRM, {
        title: this.$t("dashboard.reviewsModeration.dialogs.report.title"),
        message:
          this.$t("dashboard.reviewsModeration.dialogs.report.text") +
          `<br>` +
          `<strong>${this.reasons.find(r => r.value === this.reason).text}</strong>`,
        callback: () => {
          this.$axios
            .post("office/manager/impersonate/response/moderate", {
              //Need to provide a reason to report the review (0+reason( 1-9 ))
              confidence: this.reason,
              response: this.response,
              token: this.token,
            })
            .then(() => {
              this.$emit("moderate", 1)
              this.$emit("confidence", this.reason)
              this.step = 1
            })
        },
      })
    },
    remove() {
      this.$store.dispatch(TypesDialog.actions.CONFIRM, {
        title: this.$t("dashboard.reviewsModeration.dialogs.remove.title"),
        message: this.$t("dashboard.reviewsModeration.dialogs.remove.text"),
        callback: () => {
          this.free().then(() => {
            this.edit = false
            this.locked = false

            this.$axios
              .delete("office/manager/impersonate/response", {
                data: {
                  response: this.review.response,
                  token: this.token,
                },
              })
              .then(() => {
                this.response.message = ""
                delete this.response.id
              })

            this.$emit("remove")
          })
        },
      })
    },
    set() {
      return this.$axios.post("office/common/deadlocks/set", {
        publication_id: this.review.id,
        database: this.review.database,
      })
    },
    free() {
      return this.$axios.post("office/common/deadlocks/free", {
        publication_id: this.review.id,
        database: this.review.database,
      })
    },
  },
}
</script>
